import { useState, useEffect } from "react";
import { type Language, getPageTranslations } from "../lib/translations";
import { useDynamicContent } from "../lib/dynamicContent";
import { ContactSkeleton } from "./ui/Skeletons";
import { SocialsGrid } from "./contact/SocialsGrid";
import { ContactForm } from "./contact/ContactForm";
import { useLocation } from "react-router-dom";
import { Modal } from "./Modal";

interface ContactTabProps {
  lang: Language;
}

export function ContactTab({ lang }: ContactTabProps) {
  const t = getPageTranslations(lang).contact;
  const { loading } = useDynamicContent();
  const location = useLocation();
  const state = location.state as { showPopup?: boolean } | null;

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    if (state?.showPopup) {
      setIsPopupOpen(true);
      // Clean location state to prevent repeat popups on manual reloads
      window.history.replaceState({}, document.title);
    }
  }, [state]);

  if (loading) {
    return <ContactSkeleton />;
  }

  return (
    <div className="max-w-7xl mx-auto py-6 px-4 animate-fade-in">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
        {/* 1. Mail Contact Form */}
        <ContactForm lang={lang} t={t} />

        {/* 2. Socials Hover centerpiece card */}
        <SocialsGrid t={t} />
      </div>

      {/* Booking waiting list alert popup modal */}
      <Modal
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        title={lang === "tr" ? "Operasyonel Durum Bilgilendirmesi" : "Operational Availability Status"}
        closeLabel={lang === "tr" ? "Kapat" : "Close"}
      >
        <p className="text-sm font-semibold text-foreground/80 leading-relaxed py-2">
          {lang === "tr"
            ? "Bir sonraki uygunluk dönemine kadar bana e-posta gönderebilirsiniz."
            : "You can write an email to me while waiting for the next availability."}
        </p>
      </Modal>
    </div>
  );
}

export default ContactTab;

